var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 1.66663H12.6667C14.0668 1.66663 14.7669 1.66663 15.3016 1.93911C15.772 2.17879 16.1545 2.56124 16.3942 3.03165C16.6667 3.56643 16.6667 4.26649 16.6667 5.66663V14.3333C16.6667 15.7334 16.6667 16.4335 16.3942 16.9683C16.1545 17.4387 15.772 17.8211 15.3016 18.0608C14.7669 18.3333 14.0668 18.3333 12.6667 18.3333H7.33333C5.9332 18.3333 5.23314 18.3333 4.69836 18.0608C4.22795 17.8211 3.8455 17.4387 3.60582 16.9683C3.33333 16.4335 3.33333 15.7334 3.33333 14.3333V13.75M13.3333 10.8333H9.58333M13.3333 7.49996H10.4167M13.3333 14.1666H6.66667M5 8.33329V3.74996C5 3.0596 5.55964 2.49996 6.25 2.49996C6.94036 2.49996 7.5 3.0596 7.5 3.74996V8.33329C7.5 9.714 6.38071 10.8333 5 10.8333C3.61929 10.8333 2.5 9.71401 2.5 8.33329V4.99996",
    stroke: "#9A9DAD",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDocument);
export default __webpack_public_path__ + "static/media/business-document.10a3fb56.svg";
export { ForwardRef as ReactComponent };